module.exports = __webpack_public_path__ + "media/images/bank_images/safra-46794574f20f3b518cf7c0efd72c7907.png";